"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
const property_1 = require("@genesys/property");
function propertyDefinition() {
    return [
        {
            sort_no: 10,
            name: "coilstaggered",
            group: "",
            quantity: "Discrete",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: [
                {
                    sort_no: 0,
                    value: {
                        type: "integer",
                        value: 0
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 1,
                    value: {
                        type: "integer",
                        value: 1
                    },
                    property_filter: property_1.PropertyFilter.Empty
                }
            ]
        },
        {
            sort_no: 20,
            name: "coilrows",
            group: "",
            quantity: "Discrete",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: [
                {
                    sort_no: 1,
                    value: {
                        type: "integer",
                        value: 1
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 2,
                    value: {
                        type: "integer",
                        value: 2
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 3,
                    value: {
                        type: "integer",
                        value: 3
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 4,
                    value: {
                        type: "integer",
                        value: 4
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 5,
                    value: {
                        type: "integer",
                        value: 5
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 6,
                    value: {
                        type: "integer",
                        value: 6
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 7,
                    value: {
                        type: "integer",
                        value: 7
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 8,
                    value: {
                        type: "integer",
                        value: 8
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 9,
                    value: {
                        type: "integer",
                        value: 9
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 10,
                    value: {
                        type: "integer",
                        value: 10
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 11,
                    value: {
                        type: "integer",
                        value: 11
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 12,
                    value: {
                        type: "integer",
                        value: 12
                    },
                    property_filter: property_1.PropertyFilter.Empty
                }
            ]
        },
        {
            sort_no: 30,
            name: "coildistbtwrows",
            group: "",
            quantity: "Length",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 40,
            name: "coiltubesinheight",
            group: "",
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 50,
            name: "coiltubelength",
            group: "",
            quantity: "Length",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 60,
            name: "coildistbtwtubes",
            group: "",
            quantity: "Length",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 70,
            name: "coilcircuitsorpasses",
            group: "",
            quantity: "Discrete",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: [
                {
                    sort_no: 1,
                    value: {
                        type: "integer",
                        value: 1
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 2,
                    value: {
                        type: "integer",
                        value: 2
                    },
                    property_filter: property_1.PropertyFilter.Empty
                }
            ]
        },
        {
            sort_no: 71,
            name: "coilcircuits",
            group: "",
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.fromString("coilcircuitsorpasses=1") ||
                property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 72,
            name: "coilpasses",
            group: "",
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.fromString("coilcircuitsorpasses=2") ||
                property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 80,
            name: "coilfinspacingorfinsperlength",
            group: "",
            quantity: "Discrete",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: [
                {
                    sort_no: 1,
                    value: {
                        type: "integer",
                        value: 1
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 2,
                    value: {
                        type: "integer",
                        value: 2
                    },
                    property_filter: property_1.PropertyFilter.Empty
                }
            ]
        },
        {
            sort_no: 81,
            name: "coilfinspacing",
            group: "",
            quantity: "Length",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.fromStringOrEmpty("coilfinspacingorfinsperlength=1"),
            value: []
        },
        {
            sort_no: 82,
            name: "coilfinsperinch",
            group: "",
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.fromStringOrEmpty("coilfinspacingorfinsperlength=2"),
            value: []
        },
        {
            sort_no: 90,
            name: "coilheight",
            group: "",
            quantity: "Length",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 100,
            name: "coilwidth",
            group: "",
            quantity: "Length",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 110,
            name: "coilconnectionside",
            group: "",
            quantity: "Discrete",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: [
                {
                    sort_no: 1,
                    value: {
                        type: "integer",
                        value: 1
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 2,
                    value: {
                        type: "integer",
                        value: 2
                    },
                    property_filter: property_1.PropertyFilter.Empty
                }
            ]
        },
        {
            sort_no: 120,
            name: "coilexchangerflowtype",
            group: "",
            quantity: "Discrete",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: [
                {
                    sort_no: 1,
                    value: {
                        type: "integer",
                        value: 1
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 2,
                    value: {
                        type: "integer",
                        value: 2
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 3,
                    value: {
                        type: "integer",
                        value: 3
                    },
                    property_filter: property_1.PropertyFilter.Empty
                }
            ]
        }
    ];
}
//# sourceMappingURL=coil-definition.js.map